// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"180":"36b3e73f","730":"ea32a216","875":"6c468fd8"}[chunkId] + ".css";
};